import builder from '../builder';
import kitchenShelf from '../../streamline-icons/bold/kitchen-shelf.svg';

export default builder('IconkitchenShelfBold', kitchenShelf);
